const MAX_PICTURE_SIDE_PX = 1200;
const JPEG_QUALITY = 0.9;

/** The image file as a JPEG at most 1200px on its longer side, as base64 without the data-url prefix. */
export function encodePictureAsJpegBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
        const objectUrl = URL.createObjectURL(file);
        const image = new Image();
        image.onload = () => {
            URL.revokeObjectURL(objectUrl);
            const scale = Math.min(1, MAX_PICTURE_SIDE_PX / Math.max(image.width, image.height));
            const canvas = document.createElement('canvas');
            canvas.width = Math.round(image.width * scale);
            canvas.height = Math.round(image.height * scale);
            const context = canvas.getContext('2d');
            if (!context) {
                reject(new Error('Canvas is not available'));
                return;
            }
            // JPEG has no alpha channel: what is transparent in the source would otherwise turn black.
            context.fillStyle = 'white';
            context.fillRect(0, 0, canvas.width, canvas.height);
            context.drawImage(image, 0, 0, canvas.width, canvas.height);
            resolve(canvas.toDataURL('image/jpeg', JPEG_QUALITY).split(',')[1]);
        };
        image.onerror = () => {
            URL.revokeObjectURL(objectUrl);
            reject(new Error('The file is not a readable image'));
        };
        image.src = objectUrl;
    });
}
